import React from 'react'

import AceEditor from 'react-ace'
import 'ace-builds/webpack-resolver'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/theme-monokai'

import jsbeautifier from 'js-beautify'

import { Row, Col, Button } from 'react-bootstrap'

import copy from 'copy-to-clipboard'


const InputArea = props => {
  const beautifyJson = () => {
    const editor = document.getElementById('inputEditor').env.editor

    const options = {
      indent_size: 2,
      indent_char: ' ',
      jslint_happy: true,
      brace_style: 'end-expand',
      keep_array_indentation: true
    }
    editor.setValue(jsbeautifier.js_beautify(editor.getValue(), options))
    editor.session.setScrollLeft(0)
  }

  const copyToClipboard = () => {
    const editor = document.getElementById('inputEditor').env.editor
    copy(editor.getValue())
  }

  const clear = () => {
    const editor = document.getElementById('inputEditor').env.editor
    editor.setValue('')
  }

  return (
    <div>
      <Row>
        <Col xs={4}>
          <h5>JSON data</h5>
        </Col>
        <Col className='text-right'>
          <Button
            variant='secondary'
            className='btn-sm'
            onClick={() => beautifyJson()}
          >
            Format
          </Button>
          <Button
            variant='secondary'
            className='btn-sm ml-2'
            onClick={() => clear()}
          >
            Clear
          </Button>
          <Button
            variant='secondary'
            className='btn-sm ml-2'
            onClick={() => copyToClipboard()}
          >
            Copy
          </Button>
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col>
          <AceEditor
            mode='json'
            theme='monokai'
            fontSize={14}
            width='100%'
            height='75vh'
            onChange={event => props.handleChange(event)}
            name='inputEditor'
            tabSize={2}
            debounceChangePeriod={500}
            value={props.value}
            editorProps={{ $blockScrolling: true }}
          />
        </Col>
      </Row>
    </div>
  )
}

export default InputArea
